//  This is how long it takes the drawer animation to complete
//  We store it as a constant so that we can sync the UI animation
//  and the actual clearing of the `issueDetails` in the store,
//  so that when we close the drawer it doesn't look empty as it closes.
export const ISSUE_DRAWER_SLIDE_DURATION = 500; // in ms
